import {
  Assignment,
  Call,
  Assessment,
  Close,
  Campaign,
} from '@mui/icons-material';
import { permit } from '@lba-dev/package.local-globals/restrictions';
import { fromJS, Map } from 'immutable';

import {
  appel,
  callReminderDialog,
  hideFromMissingRib,
  sendInstructions,
  sendTutoCbVideoSms,
  envoyerMailAssuranceExpirée,
  sendSMS,
} from '../../../actions/artisan';

export default [
  {
    name: 'Modifier',
    icon: Assignment,
    link: ({ id }) => {
      window.open(`/artisan/${id}`);
    },
    action: (props, elem) => {
      props.navigate(`/artisan/${elem.id}`);
    },
    customVisible: (elem, props) => permit(props.user, { key: 'editArtisan' }),
  },
  {
    name: 'Appeler',
    icon: Call,
    sub: [1, 2, 3].map((e) => ({
      name: `Téléphone Artisan ${e}`,
      value: `tel${e}`,
      action: (props, elem) => {
        appel(
          {
            artisan: new Map(elem),
            intervention: props.intervention,
          },
          elem[`tel${e}`]
        ).then((appelId) => {
          if (typeof props.artisanAppel === 'function') {
            props.artisanAppel(appelId, elem._id);
          }
        });
      },
    })),
    customVisible: (elem, props) =>
      props.selected &&
      (!props.selected.checkNumber ||
        props.userIdSelected === props.selected._id),
  },
  {
    name: 'Recap',
    icon: Assessment,
    link: ({ id }) => window.open(`/artisan/${id}/recap`),
    action: (props, elem) => {
      props.navigate(`/artisan/${elem.id}/recap`);
    },
  },
  {
    name: 'Communication',
    icon: Campaign,
    sub: [
      {
        name: 'Envoyer l\'adresse des chèques',
        action: sendInstructions,
        customVisible: (elem, props) =>
          props.selected && !props.selected.sentInstructions,
      },
      {
        name: 'Renvoyer l\'adresse des chèques',
        action: sendInstructions,
        customVisible: (elem, props) => {
          const user = props.users.find((u) => u._id === props.userId);

          return (
            user &&
              props.selected &&
              props.selected.sentInstructions &&
              permit(user, { key: 'resendInstructions' })
          );
        },
      },
      {
        name: 'Relance doc (mail)',
        action: callReminderDialog,
      },
      {
        name: 'Relance doc (message)',
        action: (p, elem) => sendSMS({ ...p, artisan: fromJS(elem) }),
      },
      {
        name: 'Tuto lien CB',
        action: sendTutoCbVideoSms,
      },
      {
        name: 'Mail assurance expirée',
        action: envoyerMailAssuranceExpirée,
      }
    ],
  },
  {
    name: 'Enlever de la liste',
    icon: Close,
    action: (props, artisan) => hideFromMissingRib(artisan._id),
  },
];
